export default [
  {
    value: 'draft',
    label: 'Draft',
  },
  {
    value: 'scheduled',
    label: 'Assigned (Scheduled)',
  },
  {
    value: 'assigned',
    label: 'Assigned',
  },
  {
    value: 'saved_for_later',
    label: 'Saved For Later',
  },
  {
    value: 'started',
    label: 'Started',
  },
  {
    value: 'in_progress',
    label: 'In Progress',
  },
  {
    value: 'sessions_completed',
    label: 'Sessions Completed',
  },
  {
    value: 'completed',
    label: 'Completed',
  },
  {
    value: 'deleted',
    label: 'Deleted',
  },
];
